function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), React.createElement("path", {
    "data-name": "Path 887",
    d: "M13.4 9.2a.6.6 0 0 0-.6.6v2.4a.6.6 0 0 1-.6.6H3.8a.6.6 0 0 1-.6-.6V9.8a.6.6 0 0 0-1.2 0v2.4A1.8 1.8 0 0 0 3.8 14h8.4a1.8 1.8 0 0 0 1.8-1.8V9.8a.6.6 0 0 0-.6-.6zm-5.826 1.026a.6.6 0 0 0 .2.126.564.564 0 0 0 .456 0 .6.6 0 0 0 .2-.126l2.4-2.4a.6.6 0 0 0-.852-.852L8.6 8.354V2.6a.6.6 0 1 0-1.2 0v5.754l-1.374-1.38a.6.6 0 1 0-.852.852z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#fff"
    }
  }));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.67426fc3.svg";
export { ForwardRef as ReactComponent };